import type { Client } from "../types/clientTypes";

export function getClientName(client: Pick<Client, "firstName" | "lastName">) {
  return [client.firstName?.trim(), client.lastName?.trim()].filter(Boolean).join(" ") || "Unnamed customer";
}

export function matchesClientSearch(client: Client, search: string) {
  const query = search.trim().toLocaleLowerCase();
  if (!query) return true;
  if ([getClientName(client), client.email, client.phoneNumber].some((value) => value?.toLocaleLowerCase().includes(query))) {
    return true;
  }
  const digits = query.replace(/\D/g, "");
  return !!digits && /^[+\d\s().-]+$/.test(query) && !!client.phoneNumber?.replace(/\D/g, "").includes(digits);
}
